// extracted by mini-css-extract-plugin
module.exports = {"checkboxes":"checkboxes__8chWi","h3":"h3__EZgMl","inputError":"inputError__mZbdf"};